export class GhostPosts {
  constructor(config = {}) {
    this.isInitialized = false

    // !!TBC by client!!
    // this.ghostUrl = "https://threshold-network.ghost.io"
    this.ghostUrl = "https://threshold-network.ghost.io/blog"
    this.apiKey = "92bf2e734c4713627111f5976c"

    this.blogCards = this.getBlogCards()
    this.blogCardWrapper = document.querySelector(".blog_card_wrap")?.parentElement?.parentElement

    this.posts = []
    this.loading = true
  }

  getBlogCards() {
    const cardWraps = document.querySelectorAll(".blog_card_wrap")

    return Array.from(cardWraps).map(cardWrap => {
      const card = cardWrap.closest("[class*='blog_card']") || cardWrap.parentElement

      return {
        container: card,
        tagWrap: card.querySelector(".blog_card_tag_wrap"),
        tag: card.querySelector(".blog_card_tag"),
        image: card.querySelector(".blog_card_image"),
        title: card.querySelector(".blog_card_title"),
        excerpt: card.querySelector(".blog_card_excerpt"),
        date: card.querySelector(".blog_card_date"),
        readtime: card.querySelector(".blog_card_readtime"),
        link: card.querySelector(".blog_card_link a") || card.querySelector("a")
      }
    })
  }

  init() {
    if (this.isInitialized) return

    this.showLoading()
    this.fetchPosts()
    this.isInitialized = true
  }

  async fetchPosts() {
    try {
      const limit = this.blogCards.length || 5
      const apiUrl = `${this.ghostUrl}/ghost/api/content/posts/?key=${this.apiKey}&include=authors,tags&limit=${limit}`
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Accept-Version": "v5.0"
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      this.posts = data.posts || []
      await this.renderPosts()
      this.hideLoading()
    } catch (err) {
      console.error("Error fetching posts:", err)
      this.hideLoading()
    }
  }

  async renderPosts() {
    const imagePromises = []

    this.blogCards.forEach((card, index) => {
      const post = this.posts[index]

      if (!post) {
        // Hide card if no post data avail
        card.container?.classList.add("is-hidden")
        return
      }

      // Show card
      card.container?.classList.remove("is-hidden")

      // tag - primary_tag or first tag
      const tagName = post.primary_tag?.name || post.tags?.[0]?.name
      if (tagName && card.tag) {
        card.tag.textContent = tagName
        card.tagWrap?.classList.remove("is-hidden")
      } else {
        card.tagWrap?.classList.add("is-hidden")
      }

      // image
      if (card.image && post.feature_image) {
        if (card.image.tagName === "IMG") {
          const promise = new Promise((resolve) => {
            if (card.image.complete) {
              resolve()
            } else {
              card.image.onload = resolve
              card.image.onerror = resolve
            }
          })
          imagePromises.push(promise)

          card.image.src = post.feature_image
          card.image.alt = post.title
        } else {
          card.image.style.backgroundImage = `url(${post.feature_image})`
        }
      }

      // title
      if (card.title) {
        card.title.textContent = post.title
      }

      // excerpt
      if (card.excerpt) {
        card.excerpt.textContent = post.custom_excerpt || post.excerpt || ""
      }

      // date
      if (card.date) {
        card.date.textContent = this.formatDate(post.published_at)
      }

      // read time
      if (card.readtime) {
        card.readtime.textContent = `${post.reading_time} min read`
      }

      // link
      if (card.link) {
        card.link.href = post.url
        card.link.target = "_blank"
        card.link.rel = "noopener noreferrer"
      }
    })

    // Wait for all images to load
    await Promise.all(imagePromises)

    // Trigger reflow
    window.dispatchEvent(new Event('resize'))

  }

  formatDate(dateString) {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    })
  }

  showLoading() {
    this.loading = true
    this.blogCardWrapper?.classList.add("is-loading")
  }

  hideLoading() {
    this.loading = false
    this.blogCardWrapper?.classList.remove("is-loading")
  }

  destroy() {
    this.posts = []
    this.loading = false
    this.isInitialized = false
  }
}